import { queryKeys } from "../queryKeys";
import {
  type GetPortfolioArgs,
  getPortfolioHistory,
  type PortfolioHistoryResponse,
} from "../rest/portfolio";
import { useRequest } from ".";
import type { QueryOptions } from "./useRequest";

// Cache portfolio data for 5 minutes
const PORTFOLIO_CACHE_TIME = 5 * 60 * 1000;
// Consider data stale after 2 minutes
const PORTFOLIO_STALE_TIME = 2 * 60 * 1000;

interface UseGetPortfolioHistoryArgs extends GetPortfolioArgs {
  options?: QueryOptions<PortfolioHistoryResponse>;
}

export const useGetPortfolioHistory = ({
  options,
  ...rest
}: UseGetPortfolioHistoryArgs) => {
  const {
    accountID,
    product,
    period,
    intraday_reporting,
    start,
    end,
    pnl_reset,
    timeframe,
  } = rest;
  const { data, ...restResponse } = useRequest(
    queryKeys.portfolioHistory({
      accountID,
      product,
      period,
      intradayReporting: intraday_reporting,
      start,
      end,
      pnlReset: pnl_reset,
      timeframe,
    }),
    () => getPortfolioHistory({ ...rest }),
    {
      gcTime: PORTFOLIO_CACHE_TIME,
      staleTime: PORTFOLIO_STALE_TIME,
      ...options,
      enabled: !!rest?.accountID,
      // Suppress the shared error toast for this query (duplicate error handling).
      meta: { showErrorToast: false },
    },
  );

  return { portfolio: data, ...restResponse };
};

export default useGetPortfolioHistory;
